/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A export icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function ExportIcon({ size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M9 4.694v1H2v13h13v-7h1v7.004a.997.997 0 01-1 .996H2c-.552 0-1-.444-1-.996V5.69a.998.998 0 011-.996h7zm9.5-3c.263 0 .5.237.5.5v5c0 .263-.237.477-.5.477s-.5-.214-.5-.477V3.378l-9.658 9.671a.473.473 0 01-.342.148.496.496 0 01-.354-.845l9.67-9.658H13.5c-.263 0-.477-.237-.477-.5s.214-.5.477-.5z"
      />
    </svg>
  );
}
